import { getCookie } from "cookies-next";
import { axiosInstance } from "../rest/axios";
import axios from "axios";
import { getUuidFileName } from "../util/file-extensions";
import { compressFile } from "../util/file-compressor";
import { R2Module } from "./model";

export class R2Service {
  async getFileUrls(
    module: string,
    fileName: string,
    businessId?: string,
    categoryId?: string,
  ) {
    const response = await axiosInstance.post(
      "r2/object-url",
      {
        module: module,
        business_id: businessId,
        category_id: categoryId,
        file_id: getUuidFileName(fileName),
      },
      { headers: { Authorization: getCookie("Authorization")?.toString() } },
    );

    return response.data;
  }

  async getFileUrlsForAdmin(
    module: string,
    fileName: string,
    businessId?: string,
    categoryId?: string,
  ) {
    const response = await axiosInstance.post(
      "_admin/r2/object-url",
      {
        module: module,
        business_id: businessId,
        category_id: categoryId,
        file_id: getUuidFileName(fileName),
      },
      { headers: { Authorization: getCookie("Authorization")?.toString() } },
    );

    return response.data;
  }

  async putFileToGivenUrl(url: string, file: any) {
    const response = await axios.put(url, file);
    return response.data;
  }

  async deleteFile(
    module: string,
    url: string,
    businessId?: string,
    categoryId?: string,
  ) {
    const response = await axiosInstance.delete("r2/object", {
      data: {
        module: module,
        url: url,
        business_id: businessId,
        category_id: categoryId,
      },
      headers: { Authorization: getCookie("Authorization")?.toString() },
    });

    return response.data;
  }

  async upload(
    file: File,
    module: R2Module,
    businessId?: string,
    category_id?: string,
  ): Promise<string> {
    const compressedFile = await compressFile(file);
    if (module === R2Module.canbookTemplateMedia) {
      const { upload_url, download_url } = await this.getFileUrlsForAdmin(
        module,
        compressedFile.name,
        businessId,
        category_id,
      );
      await this.putFileToGivenUrl(upload_url, compressedFile);
      return download_url;
    } else {
      const { upload_url, download_url } = await this.getFileUrls(
        module,
        compressedFile.name,
        businessId,
        category_id,
      );
      await this.putFileToGivenUrl(upload_url, compressedFile);
      return download_url;
    }
  }
}

export const r2Service = new R2Service();
